module.exports = __webpack_public_path__ + "static/media/Circle.19f1b1b2.png";